import {
  AutocompleteInput,
  ReferenceInput,
  ReferenceInputProps,
  useListContext,
} from "react-admin";
import { Box } from "@mui/material";
import { FiltersCommonInputProps } from "../../../types/default";

const AutoCompleteInput = (
  props: ReferenceInputProps &
    FiltersCommonInputProps & {
      attributes_to_get: string;
      search_attribute: string;
      /* a list of filter names. Only those filters are sent to the backend */
      filters?: [string];
    },
) => {
  const {
    filters = [],
    attributes_to_get: attributes,
    search_attribute,
    sort,
    ...rest
  } = props;
  const { filterValues } = useListContext();
  return (
    <Box width={"100%"}>
      <ReferenceInput
        {...rest}
        queryOptions={{
          meta: { attributes, search_attribute },
        }}
        filter={{
          search_attribute_value: filterValues[props.source],
          // expose only filters from filters props
          ...Object.fromEntries(
            filters.map((filter) => [filter, filterValues[filter]]),
          ),
        }}
        sort={sort ?? { field: search_attribute, order: "ASC" }}
      >
        <AutocompleteInput
          filterToQuery={(search) => ({ search })}
          optionText={search_attribute}
          optionValue={search_attribute}
          size="small"
        />
      </ReferenceInput>
    </Box>
  );
};

export default AutoCompleteInput;
